import React from 'react';
import { useStringsContext } from '../../../../contexts/strings';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import { FormControlLabel, Switch } from '@mui/material';
import SceneHeader from '../../../common/scene/scene-header';

interface Props {
  onAdd: (event: React.MouseEvent) => void;
  reactionsEnabled: boolean;
  onReactionsChanged: (enabled: boolean) => void;
  isReadOnly: boolean;
}

const StoryListHeader = ({ onAdd, reactionsEnabled, onReactionsChanged, isReadOnly }: Props) => {
  const { strings } = useStringsContext();

  return (
    <SceneHeader title={strings.appBar.stories}>
      <FormControlLabel
        control={
          <Switch
            onChange={() => onReactionsChanged(!reactionsEnabled)}
            checked={reactionsEnabled}
          />
        }
        label={strings.stories.globalToggleReactions}
        disabled={isReadOnly}
      />
      <Button variant="contained" onClick={onAdd} startIcon={<AddIcon />} disabled={isReadOnly}>
        {strings.stories.addStory}
      </Button>
    </SceneHeader>
  );
};

export default StoryListHeader;
